
import { defineComponent, PropType } from 'vue';
import Message from '@/models/MessageModel';
import AnswerButton from '@/components/App/AnswerButton/index.vue';
import CalculaterButtonWidth from '@/helpers/CalculaterButtonWidth';

import MessageWrap from '@/components/MessageWrap/index.vue';
import Button from '@/models/ButtonModel';

export default defineComponent({
	name: 'location',

	components: {
		MessageWrap,
		AnswerButton
	},

	props: {
		message: {
			type: Object as PropType<Message>
		},

		isShowMessageTail: {
			type: Boolean
		},

		isLastMessage: {
			type: Boolean
		},

		avatar: {
			type: String
		}
	},

	emits: ['send-message', 'init'],

	setup() {
		return { CalculaterButtonWidth };
	},

	mounted() {
		this.$emit('init');
	},

	created() {
		if ('geolocation' in navigator) {
			console.log('geolocation is available');
		} else {
			console.log('geo is not available now');
		}
	},

	methods: {
		// Перехватываем payload с компонента нажатой кнопки
		// И довносим в него еще данные о гео локации
		addGeo(payload: Button): void {
			if ('geolocation' in navigator) {
				navigator.geolocation.getCurrentPosition((position: GeolocationPosition) => {
					payload.text = `${position.coords.latitude},${position.coords.longitude}`;
					payload.type = 'location';

					this.sendMessage(payload);
				});
			} else {
				this.$q.notify({
					color: 'negative',
					message: 'cannot get geo position' // TODO lang widgetGetGeoErrorMessage
				});
			}
		},

		sendMessage(payload: Button) {
			this.$emit('send-message', payload);
		}
	}
});
